import React, { Component } from 'react'
import PropTypes from 'prop-types'
import PublishedComment from './PublishedComment'

export default class CommentsList extends Component {
  render() {
    const { user, quest, section, showingResolvedComments, dispatch } =
      this.props
    var comments = this.props.comments.map(function (comment, index) {
      // ** hack alert ** - really, really hate the random param but was stuck on the Comment component
      // not re-rendering when the comment.status property was updated when
      // re-opening or resolving comments
      return (
        <PublishedComment
          comment={comment}
          key={index}
          showingResolvedComments={showingResolvedComments}
          random={Math.random()}
          user={user}
          quest={quest}
          section={section}
          dispatch={dispatch}
        />
      )
    })

    return <ul className="comments-list">{comments}</ul>
  }
}

CommentsList.propTypes = {
  comments: PropTypes.array.isRequired,
  showingResolvedComments: PropTypes.bool,
  user: PropTypes.object.isRequired,
  quest: PropTypes.object.isRequired,
  section: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/components/mini/comments/CommentsList.js